exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.map[data-v-671f092e] {\n  height: 300px;\n  width: 100%;\n}\n", ""]);

// exports
